import { pgTable, uuid, text, boolean, timestamp } from "drizzle-orm/pg-core";
import { priceLists } from "./price-lists.js";

export const customerGroups = pgTable("customer_groups", {
  id: uuid("id").primaryKey().defaultRandom(),
  code: text("code").notNull().unique(),
  name: text("name").notNull(),
  priceListId: uuid("price_list_id")
    .notNull()
    .references(() => priceLists.id),
  vatDisplay: text("vat_display").notNull().$type<"inc" | "exc">(),
  isBusiness: boolean("is_business").notNull().default(false),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
});

export type CustomerGroup = typeof customerGroups.$inferSelect;
export type NewCustomerGroup = typeof customerGroups.$inferInsert;

export const CUSTOMER_GROUP_CODES = ["b2c", "b2b_a", "b2b_b"] as const;
export type CustomerGroupCode = (typeof CUSTOMER_GROUP_CODES)[number];
